/**
 * Banner
 */

const Banner = (function($) {
  "use strict";

  function initBanner() {
    const $banner = $(".Banner");
    const now = new Date().getTime();
    const timestamp = JSON.parse(localStorage.getItem("hide_banner"));

    // if timestamp is from the last 30 days
    if (timestamp && timestamp > now - 30 * 24 * 60 * 60 * 1000) {
      $banner.addClass("is-hidden");
    }

    $(".Banner-close").on("click", function(e) {
      const timestamp = new Date().getTime();
      e.preventDefault();
      $banner.addClass("is-hidden");
      localStorage.setItem("hide_banner", timestamp);
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".Banner").length) {
      return;
    }

    initBanner();
  }

  return {
    init
  };
})(jQuery);

jQuery(document).ready(Banner.init);
